'use client';

import { useAppContext } from '@bw/ui';
import { FC, useCallback } from 'react';
import { Button, ButtonProps } from './Buttons';

type Props = ButtonProps;

export const StepperButton: FC<Props> = (props) => {
	const { showFormStepper, setShowFormStepper } = useAppContext();

	const onClick = useCallback(() => {
		props.onClick?.();
		// if (storeNumber) {
		// 	localStorage.setItem('storeNumber', storeNumber);
		// }
		setShowFormStepper(!showFormStepper);
	}, [showFormStepper, setShowFormStepper, props.onClick]);

	return <Button {...props} onClick={onClick} />;
};
